import { useEffect, useState } from 'react';

/**
 * Menunda perubahan nilai sampai pengguna berhenti mengetik.
 *
 * Tanpa ini, kolom pencarian mengirim satu permintaan per huruf - "marketplace"
 * jadi sebelas permintaan yang hasilnya bisa tiba tidak berurutan.
 */
export const useDebounced = (value, delay = 300) => {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debounced;
};
